import { logUserInteraction } from "~vue/utils/logUtils";

export type JourneysTab = "for-you" | "for-your-team" | "completed";

export type JourneysSection =
    | "priority_goals" // Priority Goals column (right on For you)
    | "suggestions" // Nadia's suggestions section
    | "other_goals" // Non-prioritized tracked goals on For you
    | "unassigned_goals" // Unassigned goals on For your team
    | "team_lane" // A specific team member's assigned goals lane
    | "completed"; // Completed goals tab

export const JourneysAmplitudeEventNames = {
    PAGE_VIEWED: "journeys_page_viewed",
    TAB_CLICKED: "journeys_tab_clicked",
    GOAL_CARD_CLICKED: "journeys_goal_card_clicked",
    GOAL_DRAGGED: "journeys_goal_dragged",
    GOAL_DROPPED: "journeys_goal_dropped",
    GOAL_COMPLETED: "journeys_goal_completed",
    GOAL_CREATED: "journeys_goal_created",
    GOAL_EDITED: "journeys_goal_edited",
    GOAL_DISCARDED: "journeys_goal_discarded",
    GOAL_TRACKED: "journeys_goal_tracked",
    GOAL_ACTION_ADDED: "journeys_goal_action_added",
    GOAL_ACTION_COMPLETED: "journeys_goal_action_completed",
    GOAL_ACTION_DELETED: "journeys_goal_action_deleted",
    GOAL_CONNECTION_ASSIGNED: "journeys_goal_connection_assigned",
    DISCUSS_WITH_NADIA_CLICKED: "journeys_discuss_with_nadia_clicked",
    GOAL_MORE_MENU_OPENED: "journeys_goal_more_menu_opened",
    GOAL_EDIT_CLICKED: "journeys_goal_edit_clicked",
    GOAL_ASSIGN_CLICKED: "journeys_goal_assign_clicked",
    NADIA_SUGGESTIONS_INFO_OPENED: "journeys_nadia_suggestions_info_opened",
    PRIORITY_GOALS_INFO_OPENED: "journeys_priority_goals_info_opened",
    ADD_GOAL_CLICKED: "journeys_add_goal_clicked",
    MANAGER_BANNER_SHOWN: "journeys_manager_banner_shown",
    MANAGER_BANNER_SUBMITTED: "journeys_manager_banner_submitted",
} as const;

export interface GoalDroppedExtraData extends Record<string, unknown> {
    goal_id: string;
    from_section: JourneysSection;
    to_section: JourneysSection;
    connection_id?: string;
    from_connection_id?: string | null;
}

export interface GoalTrackedExtraData extends Record<string, unknown> {
    goal_id: string;
    method: "drag" | "button" | "priority_button";
    to_section: JourneysSection;
    is_team_goal: boolean;
}

export interface GoalPrioritizedExtraData extends Record<string, unknown> {
    goal_id: string;
    method: "drag" | "button";
    new_state: "prioritized" | "unprioritized";
}

export interface DiscussWithNadiaClickedExtraData extends Record<string, unknown> {
    goal_id: string | undefined;
    source: "card" | "sidebar";
}

export const logJourneysUserInteraction = (eventType: string, extraData: Record<string, unknown> = {}, tab?: JourneysTab): void => {
    const tabData = tab !== undefined ? { tab: normalizeTab(tab) } : {};
    void logUserInteraction(eventType, { page: "journeys", ...tabData, ...extraData });
};

function normalizeTab(tab: JourneysTab): string | undefined {
    return String(tab).replaceAll("-", "_");
}
